import { put, takeLatest } from 'redux-saga/effects';
import { IsSerialOldUsed } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { sn_old, pk } }) {
    try {
        const token = yield authService.getAccessToken();

        //se sn_old è vuoto non serve che faccio la chiamata al web service
        if (sn_old === "") {
            yield put(IsSerialOldUsed.creators.isSerialOldUsedSuccess({ is_serial_old_used: false }));
        }
        else {
            const response = yield fetch('/Licenses/IsSerialOldUsed/' + sn_old + '/' + pk, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });


            const responseResult = yield response.text();

            let is_serial_old_used;

            if (responseResult === 'false') is_serial_old_used = false;
            else is_serial_old_used = true;


            yield put(IsSerialOldUsed.creators.isSerialOldUsedSuccess({ is_serial_old_used: is_serial_old_used }));
        }

    } catch (e) {
        yield put(IsSerialOldUsed.creators.isSerialOldUsedFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(IsSerialOldUsed.types.IS_SN_OLD_USED_REQUEST, runAction);
}